module.exports = __webpack_public_path__ + "images/emoji/tokyo_tower.ddd3301cccb1aa22bfd0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tokyo_tower.png
// module id = hrQd
// module chunks = 2